module.exports = __webpack_public_path__ + "static/img/200249.bbba0cf6.png";